import { ApisauceInstance } from 'apisauce'

import { Config } from '@flowwai-frontend/bps-officer-web/env-config'
import {
   Create,
   HTTP_ACCEPT_HEADER_VALUE,
   HTTP_CACHE_CONTROL_HEADER_VALUE,
   HTTP_CONTENT_TYPE_HEADER_VALUE,
   HTTP_PRAGMA_HEADER_VALUE
} from '@flowwai-frontend/shared/auth/common'
import { isAPISuccess } from '@flowwai-frontend/shared/utils/common'

import endpoints from '../endPoints'
import { LogoutAPIRequestType } from '../types'

import LogoutService from './'

const BASE_URL = Config.BACKEND_REST_URL

const URL = `${BASE_URL}api/iam/`

export class LogoutServiceAPI implements LogoutService {
   api: ApisauceInstance
   constructor(create: Create) {
      this.api = create({
         baseURL: URL,
         headers: {
            'Content-Type': HTTP_CONTENT_TYPE_HEADER_VALUE,
            Accept: HTTP_ACCEPT_HEADER_VALUE,
            Pragma: HTTP_PRAGMA_HEADER_VALUE,
            'Cache-Control': HTTP_CACHE_CONTROL_HEADER_VALUE
         }
      })
   }

   logoutAPI = async (requestObj: LogoutAPIRequestType): Promise<void> => {
      const response = await this.api.post<void>(endpoints.logout, requestObj)

      if (isAPISuccess(response.status)) return

      throw new Error('Something went wrong')
   }
}
